import React, { useState } from 'react';
import './ContactSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope, faPhoneAlt, faPaperPlane, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faInstagram } from '@fortawesome/free-brands-svg-icons';

const initialForm = {
  name: '',
  email: '',
  subject: '',
  message: ''
};

const subjects = [
  { value: '', label: 'Choisir un sujet', disabled: true },
  { value: 'question', label: 'Question générale' },
  { value: 'collaboration', label: 'Opportunité de collaboration' },
  { value: 'projet', label: 'Proposition de projet' },
  { value: 'devis', label: 'Demande de devis' },
  { value: 'autre', label: 'Autre' }
];

const ContactSection = () => {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [statusMsg, setStatusMsg] = useState('');

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    const { name, email, subject, message } = form;
    
    // Validation des champs requis
    if (!name || !email || !subject || !message) {
      return 'Tous les champs sont requis';
    }
    
    // Validation email
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return 'Email invalide';
    }
    
    // Protections anti-spam basiques
    if (name.length < 2 || name.length > 100) {
      return 'Le nom doit contenir entre 2 et 100 caractères';
    }
    
    if (message.length < 10 || message.length > 2000) {
      return 'Le message doit contenir entre 10 et 2000 caractères';
    }
    
    // Détection de contenu suspect
    const spamKeywords = ['viagra', 'casino', 'loan', 'bitcoin', 'crypto', 'investment'];
    const messageLC = message.toLowerCase();
    if (spamKeywords.some(keyword => messageLC.includes(keyword))) {
      return 'Votre message contient du contenu non autorisé';
    }
    
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const error = validateForm();
    if (error) {
      setStatus('error');
      setStatusMsg(error);
      return;
    }

    setStatus('loading');
    setStatusMsg('Envoi en cours...');

    try {
      const formData = new FormData();
      formData.append('access_key', '30861c97-78e7-44a4-9df6-031ec2372c20');
      formData.append('name', form.name);
      formData.append('email', form.email);
      formData.append('subject', form.subject);
      formData.append('message', form.message);
      formData.append('from_name', 'Portfolio Contact Form');
      formData.append('replyto', form.email);

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        setStatusMsg('Merci ! Votre message a été envoyé avec succès. Je reviendrai vers vous rapidement. 😊');
        setForm(initialForm);
        setTimeout(() => {
          setStatus('idle');
          setStatusMsg('');
        }, 5000);
      } else {
        throw new Error(data.message || 'Erreur lors de l\'envoi');
      }
    } catch (error) {
      console.error('Erreur détaillée:', error);
      setStatus('error');
      
      // Message d'erreur spécifique selon le type
      if (error.message.includes('reCAPTCHA')) {
        setStatusMsg('Erreur de sécurité. Rechargez la page et réessayez.');
      } else if (error.message.includes('fetch')) {
        setStatusMsg('Problème de connexion. Vérifiez votre réseau.');
      } else {
        setStatusMsg(`Erreur: ${error.message || 'Problème inconnu'}`);
      }
      
      setTimeout(() => {
        setStatus('idle');
        setStatusMsg('');
      }, 6000);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-wrapper">
        <div className="contact-header">
          <h2 className="contact-title">Me Contacter</h2>
          <p className="contact-subtitle">
            Une question ? Un projet ? Écrivez-moi !
          </p>
        </div>

        <div className="contact-container">
          <div className="contact-info">
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <div className="info-content">
                <h4>Localisation</h4>
                <p>Pfastatt, France</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="info-content">
                <h4>Email</h4>
                <p>tatiana68270wi@gmail.com</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faPhoneAlt} />
              </div>
              <div className="info-content">
                <h4>Téléphone</h4>
                <p>07.79.56.02.21</p>
              </div>
            </div>

            <div className="social-links">
              <a href="https://linkedin.com/in/tatiana-fuhrer" className="social-link" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="https://github.com/Tatitatouu" className="social-link" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href="https://www.instagram.com/tatitatoouu/" className="social-link" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>

          <div className="form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Nom complet *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Votre nom"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="votre@email.com"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Sujet *</label>
                <select
                  id="subject"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                >
                  {subjects.map((subject) => (
                    <option 
                      key={subject.value} 
                      value={subject.value}
                      disabled={subject.disabled}
                    >
                      {subject.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Décrivez votre projet ou votre demande..."
                />
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={status === 'loading'}
              >
                {status === 'loading' ? (
                  <>
                    <div className="loader"></div>
                    Envoi...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faPaperPlane} />
                    Envoyer le message
                  </>
                )}
              </button>

              <div className="form-status">
                {status === 'success' && (
                  <div className="success-message">
                    <FontAwesomeIcon icon={faCheck} />
                    {statusMsg}
                  </div>
                )}
                {status === 'error' && (
                  <div className="error-message">
                    {statusMsg}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;